import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AgentCard from '../components/AgentCard'
import Footer from '../components/layout/Footer'
import Topbar from '../components/layout/Topbar'
import ProjectCard from '../components/project/ProjectCard'
import { fetchDiscoverContent } from '../services/api'
import type { Agent, Project } from '../types'

export default function Discover() {
  const navigate = useNavigate()
  const [featuredProjects, setFeaturedProjects] = useState<Project[]>([])
  const [featuredAgents, setFeaturedAgents] = useState<Agent[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const loadContent = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await fetchDiscoverContent()
      setFeaturedProjects(data.featured_projects)
      setFeaturedAgents(data.featured_agents)
    } catch (err: any) {
      console.error('Icerik yukleme hatasi:', err)
      setError((err as Error).message ?? 'Icerik yuklenemedi')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void loadContent()
  }, [loadContent])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>      <div style={{ flex: 1, overflow: 'auto' }}>
        <Topbar />
        <div style={{ flex: 1, overflow: 'auto', padding: '20px', backgroundColor: 'var(--bg-primary)' }}>
          <div style={{ marginBottom: '30px' }}>
            <h1 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '10px', color: 'var(--text-primary)' }}>Kesfet</h1>
            <p style={{ color: 'var(--text-secondary)' }}>Onerilenprojeler ve agentlar</p>
          </div>

          {loading && <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-secondary)' }}>Yukleniyor...</div>}

          {error && !loading && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--error-color)', backgroundColor: 'var(--bg-secondary)', borderRadius: '12px' }}>
              <p style={{ fontSize: '16px', marginBottom: '10px' }}>Hata: {error}</p>
              <button onClick={() => void loadContent()} style={{ padding: '8px 16px', backgroundColor: 'var(--primary-color)', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Tekrar Dene</button>
            </div>
          )}

          {!loading && !error && (
            <>
              {/* Featured Projects */}
              <div style={{ marginBottom: '40px' }}>
                <h2 style={{ fontSize: '22px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '20px' }}>Onerilen Projeler</h2>
                {featuredProjects.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px', backgroundColor: 'var(--bg-secondary)', borderRadius: '12px' }}>
                    <p style={{ color: 'var(--text-secondary)' }}>Henuz onerilen proje yok</p>
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
                    {featuredProjects.map(project => <ProjectCard key={project.id} project={project} />)}
                  </div>
                )}
              </div>

              {/* Featured Agents */}
              <div>
                <h2 style={{ fontSize: '22px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '20px' }}>Onerilen Agentlar</h2>
                {featuredAgents.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px', backgroundColor: 'var(--bg-secondary)', borderRadius: '12px' }}>
                    <p style={{ color: 'var(--text-secondary)' }}>Henuz onerilen agent yok</p>
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
                    {featuredAgents.map(agent => <AgentCard key={agent.id} agent={agent} onClick={(id) => navigate(`/agent/${id}`)} />)}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <Footer />
      </div>
    </div>
  )
}
